import React from "react";
import SkeletonLoading from "../Layouts/SkeletonLoading/SkeletonLoading";
import { Link } from "react-router-dom";
import Countdown from "react-countdown";
import { connect } from "react-redux";
import { setSocialShareDetail } from "../../actions/shareSocial";
import { isVideo } from "../../utils/utils";
import "./ProfileNftCard.css";
import { useS3Image } from "../../hooks/useS3Image";




const ProfileNftCard = ({ item, isHome = false, setSocial, type }) => {
    let fileType = isVideo(item?.resource_type) ? "videos" : "images"
    const { resourceUrl, loading, error } = useS3Image(item?.resource_url, fileType);


    return (
        <div className={`profile-nft-card ${isHome ? "tp show" : ""}`}>
            <div className="card-content">
                {/* Title and Token ID */}
                <div className="main mb-3 align-items-center nucin mb-3">
                    <div className="left">
                        <h6 className={"HeadingEllipsis mb-0"}>
                            {(item && item.title) || <SkeletonLoading width="150px" />}
                        </h6>
                    </div>
                    <div className="right block-typ">
                        <div className="category-icon ms-auto">
                            {item && item.blockchain_token_id ? (
                                <span id="numbers">#{item.blockchain_token_id}</span>
                            ) : !item ? (
                                <SkeletonLoading width="40px" height="20px" />
                            ) : null}
                        </div>
                    </div>
                </div>

                {/* Image Section */}
                {item ? (
                    <Link to={`/detail/${item._id}`}>
                        <div className="image">
                            {isVideo(item.resource_type) ? (
                                <video key={resourceUrl} autoPlay loop muted>
                                    <source
                                        src={resourceUrl}
                                        type="video/mp4"
                                    />
                                </video>












                            ) : (
                                <img
                                    src={resourceUrl}
                                    alt={item.title}
                                />
                            )}

                            {/* Status Badge */}
                            {item.on_sale && (
                                <div className="status-badge sale-badge">
                                    <span>On Sale</span>
                                </div>
                            )}

                            {/* Blockchain Badge */}
                            {/* {item.blockchain && (
                                <div className="blockchain-badge">
                                    <span>{item.blockchain}</span>
                                </div>
                            )} */}
                        </div>
                    </Link>
                ) : (
                    <div className="image">
                        <SkeletonLoading style={{ width: "100%", height: "260px", borderRadius: "20px" }} />
                    </div>
                )}

                {/* Price Info */}
                <div className="price-section">
                    <div className="price-info">
                        {
                            type === "owned" || type === "created" ?
                                <span className="price-label">Last Sale Listing Price</span> :
                                <span className="price-label">Currently Listed For</span>
                        }

                        <span className="price-value">
                            {item ? `${item.price} NUC` : <SkeletonLoading width="80px" />}
                        </span>
                    </div>
                </div>

                {/* View Detail Button */}
                {item ? (
                    <Link to={`/detail/${item._id}`} className="view-detail-btn">
                        View Details
                    </Link>
                ) : (
                    <div className="view-detail-btn skeleton-btn">
                        <SkeletonLoading width="100%" height="40px" />
                    </div>
                )}
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
    setSocial: setSocialShareDetail,
})(ProfileNftCard);